function create_collection_item(c, field_or_cb) {
  if (field_or_cb === undefined) { field_or_cb = 'title'}
  if (typeof(field_or_cb) === 'function') {
    return option_object(c.id, field_or_cb(c));
  } else {
    return option_object(c.id, c.attributes[field_or_cb]);
  }
}

function option_object(value, text){
  return {value: value, text: text}
}

// this is alias
function options_for_select(data, field_or_cb, empty_option) {
  return compose_collection(data, field_or_cb, empty_option)
}

function compose_collection(data, field_or_cb, empty_option) {
  let collection = [];

  collection = _.map(data, (el) => {return create_collection_item(el, field_or_cb)});
  if (empty_option !== undefined) {
    collection.unshift(option_object(undefined, empty_option))
  }
  return collection;
}

function includes_array(data, target) {
  let i = 0,
      result = true;

  for(i;i<target.length; i++){
    result = _.find(data, target[i]);
    // console.log("??? ",data, target[i], result);
    if (!result) {break;}
  }

  return result !== undefined;
}

function pluralize(num, str1, str2, str5){
  num = Number(num);
  let ost = num % 10;
  if ((ost == 0) || ((ost >= 5) && (ost <= 9))  ||  ((num >= 11) && (num <= 14)) ){
    return str5;
  } else if ((ost >= 2) && (ost <= 4)) {
    return str2;
  } else {
    return str1;
  }
}

function is_empty(str){
  return (str === undefined) || (String(str).length == 0)
}

function humanized_tourists (adults, ages) {
  let str = '';
  str = `Взрослые - ${adults}`
  if (ages.length > 0) {
    str += `, Дети - ${ages.length}(${ages.join(', ')})`
  }
  return str;
}

function obj_to_arr_wo_keys(obj){
  if (typeof(obj) === 'array') return obj;
  let arr = [];
  for(let key in obj) {
    arr.push(obj[key]);
  }
  return arr;
}

export {
  options_for_select,
  compose_collection,
  includes_array,
  pluralize,
  humanized_tourists,
  obj_to_arr_wo_keys,
  is_empty,
}

